import axios from "axios"
export default axios.create({
  baseURL: "https://kanza-back-end.onrender.com/",
  // baseURL: "http://192.168.1.10:3000/",
})
